import moment from "moment";
import { pluralize } from "humanize-plus";

const localTimeFilter = () => utcDateString => moment(new Date(utcDateString)).format("MM-DD-YYYY h:mm a");

const fromNowFilter = () => utcDateString => {
	if(utcDateString) {
		return moment(new Date(utcDateString)).fromNow();
	}

	return "Never";
};

function moreIndicatorFilter($filter) {
	return (collection, limit) => {
		const modified = collection.map(x => {
			if(collection.length >= limit) {
				x._more = collection.length - limit;
			} else {
				x._more = 0;
			}
			return x;
		});
		return $filter("limitTo")(modified, limit);
	};
}

function pluralizeFilter() {
	return (display, count, includeCount) => {

		const value = pluralize(count, display);
    
		if(includeCount)
			return `${count} ${value}`;

		return value;
	};
}

export function fullNameFilter() {
	return (contact) => {

		let name = contact.FirstName;

		if(contact.MiddleName)
			name += ` ${contact.MiddleName}`;

		if(contact.LastName)
			name += ` ${contact.LastName}`;

		if(contact.Suffix)
			name += ` ${contact.Suffix}`;

		return name;
	};
}

export default angular
	.module("vesl.filters.legacy", [])
	.filter("moreIndicator", moreIndicatorFilter) // I don't think this is in use
	.filter("localTime", localTimeFilter) // I don't think this is in use
	.filter("pluralize", pluralizeFilter) // I don't think this is in use
	.filter("fromNow", fromNowFilter)
	.filter("fullName", fullNameFilter).name;